import useDocumentLink from "@/hooks/useDocumentLink";
import { FC, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PageContent from "../PageContent";
import LoadingView from "@/components/state-handlers/LoadingView";
import { showErrorToast } from "@/components/custom-toasts/toasts";
import { logger } from "@/lib/logger";
import { useWorkspaceDocumentVersionStore } from "@/stores/workspace-document-version.store";
import { openAppNavigation } from "@/lib/navigation/appNavigation";

const DocumentLinkRedirectPage: FC = () => {
  const { documentLinkId } = useParams<{
    documentLinkId: string;
  }>();
  const { useQuerySingle } = useDocumentLink();
  const navigate = useNavigate();
  const { resetWorkspaceDocumentVersionStore } =
    useWorkspaceDocumentVersionStore();

  const fetchedDocumentLink = useQuerySingle(documentLinkId);

  useEffect(() => {
    if (fetchedDocumentLink?.isFetched && fetchedDocumentLink?.data) {
      const link = fetchedDocumentLink.data;
      const opened = openAppNavigation({
        target: {
          kind: "documentLink",
          link,
          currentDocumentId: link.originDocumentId,
          context: "app",
        },
        navigate,
        onWorkspaceDocumentNavigate: resetWorkspaceDocumentVersionStore,
      });
      if (!opened) {
        logger.warn("Could not resolve where a document link points", {
          operation: "openDocumentLinkRedirect",
          linkId: link.id,
          originDocumentId: link.originDocumentId,
        });
        showErrorToast("Kunne ikke bestemme dokument type");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchedDocumentLink?.isFetched, fetchedDocumentLink?.data]);

  return (
    <PageContent title="Dokument link redirect">
      <LoadingView />
    </PageContent>
  );
};

export default DocumentLinkRedirectPage;
